import { Component } from '@angular/core';
import { HELP_CENTER_URL } from '@lib/customer-support.const';

@Component({
  selector: 'restricted',
  templateUrl: './restricted.component.html',
})
export class RestrictedComponent {
  public readonly supportBaseURL: string = HELP_CENTER_URL;
}
